/* GetMyLease OPTION B — car data. Edit prices/benchmarks here only.
   bench.ref = best broker number on the market for that trim (pre-tax, MSDs, ~$2.6–3.9k DAS)
   the page shows ref minus GML_BENCH_CUT as the customer's benchmark to beat */
window.GML_CDN = 'https://cdn.shopify.com/s/files/1/0814/0885/2217/files/';
window.GML_BENCH_CUT = 0.03;

window.GML_BRANDS = {
  'BMW': { label: 'BMW',
    models: ['2 Series','3 Series','4 Series','5 Series','7 Series','8 Series','i4','i5','i7','iX','M2','M3','M4','M5','M8','X1','X2','X3','X4','X5','X6','X7','XM','Z4'],
    deals: {
      '4 Series': { name: '2026 BMW 430i Gran Coup\u00e9', terms: '36 mo \u00b7 10k mi \u00b7 $0 down', p: 640, w: 762, city: 'Nashville, TN', img: 'car-bmw-430gc.jpg' },
      '5 Series': { name: '2026 BMW 540i xDrive', terms: '36 mo \u00b7 10k mi \u00b7 $0 down', p: 699, w: 814, city: 'Nashville, TN', img: 'car-bmw-540i.jpg' },
      'X3': { name: '2026 BMW X3 30 xDrive', terms: '36 mo \u00b7 10k mi \u00b7 $0 down', p: 519, w: 698, city: 'Nashville, TN', img: 'car-bmw-x3.jpg' }
    },
    bench: {
      '2 Series': { trim: 'M240i xDrive Coup\u00e9', ref: 808, term: 36 },
      '3 Series': { trim: '330i xDrive', ref: 474, term: 39 },
      '7 Series': { trim: '740i xDrive', ref: 857, term: 39 },
      '8 Series': { trim: '840i xDrive Coup\u00e9', ref: 1007, term: 39 },
      'i4': { trim: 'i4 xDrive40', ref: 519, term: 36 },
      'i5': { trim: 'i5 xDrive40', ref: 700, term: 36 },
      'i7': { trim: 'i7 xDrive50e', ref: 878, term: 36 },
      'M2': { trim: 'M2 Coup\u00e9', ref: 1037, term: 36 },
      'M3': { trim: 'M3 RWD manual', ref: 1350, term: 36 },
      'M4': { trim: 'M4 Coup\u00e9', ref: 1034, term: 36 },
      'M5': { trim: 'M5 Sedan', ref: 1724, term: 36 },
      'X1': { trim: 'X1 xDrive28i', ref: 400, term: 39 },
      'X5': { trim: 'X5 xDrive40i', ref: 885, term: 39 },
      'X6': { trim: 'X6 xDrive40i', ref: 1016, term: 39 },
      'X7': { trim: 'X7 xDrive40i', ref: 1064, term: 39 },
      'XM': { trim: 'XM Label', ref: 1441, term: 36 }
    } },
  'Mercedes-Benz': { label: 'Mercedes',
    models: ['AMG GT','C-Class','CLA','CLE','E-Class','EQB','EQE','EQE SUV','EQS','EQS SUV','G-Class','GLA','GLB','GLC','GLE','GLS','Maybach GLS','Maybach S-Class','S-Class','SL'],
    deals: {
      'C-Class': { name: '2026 Mercedes-Benz C 300', terms: '36 mo \u00b7 10k mi \u00b7 $0 down', p: 548, w: 674, city: 'Madison, WI', img: 'car-mb-c300.jpg' },
      'S-Class': { name: '2026 Mercedes-Benz S 580', terms: '36 mo \u00b7 7.5k mi \u00b7 $2,000 down', p: 1518, w: 1912, city: 'Madison, WI', img: 'car-mb-s580.jpg' }
    },
    bench: {} },
  'Audi': { label: 'Audi',
    models: ['A3','A4','A5','A6','A6 e-tron','A7','A8','e-tron GT','Q3','Q4 e-tron','Q5','Q6 e-tron','Q7','Q8','Q8 e-tron','RS 3','RS 5','RS 6','RS 7','RS Q8','S3','S4','S5','S6','S7','S8','SQ5','SQ7','SQ8'],
    deals: { 'Q7': { name: '2026 Audi Q7 Premium Plus', terms: '36 mo \u00b7 10k mi \u00b7 $0 down', p: 881, w: 1011, city: 'Oklahoma City, OK', img: 'car-audi-q7.jpg' } },
    bench: {} },
  'Genesis': { label: 'Genesis',
    models: ['Electrified G80','Electrified GV70','G70','G80','G90','GV60','GV70','GV80','GV80 Coupe'],
    deals: { 'GV70': { name: '2026 Genesis GV70 2.5T', terms: '36 mo \u00b7 10k mi \u00b7 $0 down', p: 577, w: 632, city: 'Lindon, UT', img: 'car-genesis-gv70.jpg' } },
    bench: {} },
  'Volvo': { label: 'Volvo',
    models: ['C40 Recharge','EX30','EX90','S60','S90','V60 Cross Country','V90 Cross Country','XC40','XC60','XC90'],
    deals: { 'XC60': { name: '2026 Volvo XC60 Core', terms: '36 mo \u00b7 10k mi \u00b7 $0 down', p: 587, w: 686, city: 'Chicago, IL', img: 'car-volvo-xc60.jpg' } },
    bench: {} }
};

window.GML_MODELS = {
  'Acura': ['ADX','Integra','MDX','RDX','RSX','TLX','ZDX'],
  'Alfa Romeo': ['Giulia','Stelvio','Tonale'],
  'Aston Martin': ['DB12','DBX','Valhalla','Vanquish','Vantage'],
  'Cadillac': ['CT4','CT5','Escalade','Escalade IQ','Lyriq','Optiq','Vistiq','XT4','XT5','XT6'],
  'Chevrolet': ['Blazer','Blazer EV','Colorado','Equinox','Equinox EV','Malibu','Silverado','Suburban','Tahoe','Trailblazer','Traverse','Trax'],
  'Ford': ['Bronco','Bronco Sport','Edge','Escape','Expedition','Explorer','F-150','F-150 Lightning','Maverick','Mustang','Mustang Mach-E','Ranger'],
  'Honda': ['Accord','Civic','CR-V','HR-V','Odyssey','Passport','Pilot','Prologue','Ridgeline'],
  'Hyundai': ['Elantra','Ioniq 5','Ioniq 6','Ioniq 9','Kona','Palisade','Santa Cruz','Santa Fe','Sonata','Tucson','Venue'],
  'Infiniti': ['Q50','QX50','QX55','QX60','QX80'],
  'Jaguar': ['E-Pace','F-Pace','I-Pace'],
  'Jeep': ['Compass','Gladiator','Grand Cherokee','Grand Cherokee L','Grand Wagoneer','Wagoneer','Wrangler','Wrangler 4xe'],
  'Kia': ['Carnival','EV6','EV9','Forte','K4','K5','Niro','Seltos','Sorento','Soul','Sportage','Telluride'],
  'Land Rover': ['Defender','Discovery','Discovery Sport','Range Rover','Range Rover Evoque','Range Rover Sport','Range Rover Velar'],
  'Lexus': ['ES','GX','IS','LC','LS','LX','NX','RX','RZ','TX','UX'],
  'Lincoln': ['Aviator','Corsair','Nautilus','Navigator'],
  'Mazda': ['CX-30','CX-5','CX-50','CX-70','CX-90','Mazda3','MX-5 Miata'],
  'McLaren': ['750S','Artura','GTS','W1'],
  'Nissan': ['Altima','Ariya','Frontier','Kicks','Leaf','Murano','Pathfinder','Rogue','Sentra','Versa','Z'],
  'Porsche': ['718 Boxster','718 Cayman','911','Cayenne','Macan','Panamera','Taycan'],
  'Subaru': ['Ascent','Crosstrek','Forester','Impreza','Legacy','Outback','Solterra','WRX'],
  'Tesla': ['Cybertruck','Model 3','Model S','Model X','Model Y'],
  'Toyota': ['4Runner','bZ4X','Camry','Corolla','Corolla Cross','Crown','GR86','Grand Highlander','Highlander','Land Cruiser','Prius','RAV4','Sequoia','Sienna','Tacoma','Tundra','Venza'],
  'Volkswagen': ['Atlas','Atlas Cross Sport','Golf GTI','Golf R','ID.4','Jetta','Taos','Tiguan']
};
Object.keys(window.GML_BRANDS).forEach(function(k){ window.GML_MODELS[k] = window.GML_BRANDS[k].models; });
window.GML_MAKES = Object.keys(window.GML_MODELS).sort(function(a,b){ return a.localeCompare(b); });
